<template>
  <div>
    <section class="content">
      <h2>详情</h2>
      <ul v-if="details != ''">
        <li>
          <label>渠道名称：</label>
          <p>{{ detail.source_name }}</p>
        </li>
        <li>
          <label>上贴数量：</label>
          <p>{{ detail.total_num }}</p>
        </li>
        <li>
          <label>成本：</label>
          <p>{{ Number(detail.total_price) + "元" }}</p>
        </li>
        <li>
          <label>简历总数：</label>
          <p>{{ detail.total_resume }}</p>
        </li>
        <li>
          <label>新简历数：</label>
          <p>{{ detail.total_new_resume }}</p>
        </li>
        <li>
          <label>总入职数：</label>
          <p>{{ detail.total_entry + "人" }}</p>
        </li>
      </ul>
      <table v-if="detail.entry_list != ''">
        <thead>
          <th>项目</th>
          <th>入职人数</th>
        </thead>
        <tbody>
          <tr v-for="(item, k) in detail.entry_list" :key="k">
            <td>{{ item.project_name }}</td>
            <td>{{ item.entry_num + "人" }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {}
    };
  },
  props: {
    details: {}
  },
  watch: {
    details() {
      this.detail = this.details;
      console.log(this.detail);
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 30px 4%;
  h2 {
    font-weight: normal;
    line-height: 24px;
    margin-bottom: 20px;
  }
  > ul {
    > li {
      margin-top: 10px;
      p,
      label {
        font-size: 14px;
        line-height: 20px;
        display: inline-block;
      }
    }
  }
  table {
    td,
    th {
      border: 1px solid #ccc;
      font-size: 14px;
      padding: 4px 10px;
    }
  }
}
</style>
